// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-dropdown-item[data-v-f76876a2] {\n  width: 100%;\n  padding: 0 !important;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 36px;\n  color: #494a4d;\n  text-align: center;\n  cursor: pointer;\n}\n.custom-dropdown-item[data-v-f76876a2]:hover {\n  color: #494a4d !important;\n  background: #f5f5f5 !important;\n}\n.custom-dropdown-item span[data-v-f76876a2] {\n  display: block;\n  width: 100%;\n  padding: 0 20px;\n}\n", ""]);
// Exports
module.exports = exports;
